import { MiraCompanyView, MiraSection, MiraSectionDocument } from "@/data/models/Mira";

/**
 * A company seen like a group, in its viewing client (Hans, Track #2610112 X6e; Taimoor 2026-10-29).
 *
 * IRES Cloud writes a company's figures into the account the Firmen list names as its viewing client, as
 * `group_{section}` documents carrying the company's Mandanten and their branches by name (`companyView`).
 * The viewing client is a MASTER that lists only itself, so Office already reads those group documents; this
 * says where the roster comes from instead of the client's own `memberClientIds`.
 */

/**
 * The company a viewing client shows, from any of its section documents (each carries the same header), or
 * null on every other client.
 */
export function companyViewOf(sections: Partial<Record<MiraSection, MiraSectionDocument>>): MiraCompanyView | null {
  for (const document of Object.values(sections)) {
    if (document?.companyView) {
      return document.companyView;
    }
  }
  return null;
}

/**
 * The Mandanten a company's viewing client compares, with their names: every Mandant of the header, a blank
 * name shown as the id rather than dropped.
 */
export function companyViewRoster(view: MiraCompanyView): { ids: string[]; names: Record<string, string> } {
  const ids = Object.keys(view.members ?? {}).filter((id) => !!id);
  const names: Record<string, string> = {};
  ids.forEach((id) => {
    names[id] = (view.members[id] || "").trim() || id;
  });
  return { ids, names };
}
